import React from 'react';
import Country from '../Country';
import { Subregion, SubregionBox, SubregionTitle } from '../CountrySelector/styles';
import { Tabs, Tab } from './styles';

const CountryTabs = ({
  regions,
  setSelectedTabIndex,
  selectedTabIndex,
  subregions,
  selectedCountryIndex,
  toggleDropdown,
  handleMenuVisibility,
  dropdownOpen,
  currentCountry,
}) => {
  return (
    <>
      <Tabs>
        {regions &&
          regions.map((region, index) => (
            <Tab
              key={index}
              onClick={() => {
                setSelectedTabIndex(index);
              }}
              className={index === parseInt(selectedTabIndex) ? 'active' : ''}
              tabIndex="-1"
            >
              {region.title}
            </Tab>
          ))}
      </Tabs>
      {selectedTabIndex !== null &&
        subregions &&
        subregions.map((subregion, sbIndex) => (
          <Subregion key={sbIndex}>
            <SubregionTitle>{subregion.title}</SubregionTitle>
            <SubregionBox data-id="subregion-box">
              {subregion.countries.map((countryItem, ciIndex) => (
                <Country
                  key={ciIndex}
                  country={countryItem}
                  index={ciIndex}
                  dropdownOpen={dropdownOpen}
                  selectedCountryIndex={selectedCountryIndex}
                  regionIndex={0}
                  selectedRegionIndex={0}
                  handleDropdownToggle={toggleDropdown}
                  handleMenuVisibility={handleMenuVisibility}
                  currentCountry={currentCountry}
                />
              ))}
            </SubregionBox>
          </Subregion>
        ))}
    </>
  );
};

export default CountryTabs;
